<template>
  <a-checkbox-group v-model:value="checkedList" :options="options" />
</template>
<script setup lang="ts">
import { ActivityTag } from '@src/scripts/type'
import { computed } from 'vue'

const props = defineProps<{
  value: string[]
}>()

const emit = defineEmits(['update:value'])

const checkedList = computed({
  get() {
    const arr: string[] = []
    props.value?.forEach(a => arr.push(a))
    return arr
  },
  set(items) {
    emit('update:value', items)
  }
})

const options = [
  { label: '生日', value: ActivityTag.Birth },
  // { label: '春节', value: ActivityTag.Spring },
]

</script>